export const ROLES = {
  SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
  FD_PRINCIPAL: 'ROLE_FD_PRINCIPAL',
  FD_CLIENT_SERVICE: 'ROLE_FD_CLIENT_SERVICE',
  FD_ANALYST: 'ROLE_FD_ANALYST',
  USER: 'ROLE_USER',
  INTERNAL_USER: 'ROLE_INTERNAL_USER',
  REPORT_ADMIN: 'ROLE_REPORT_ADMIN',
} as const satisfies Record<string, string>;

export type RoleKey = keyof typeof ROLES;
export type Role = (typeof ROLES)[RoleKey];

export const ROLE_NAMES: Role[] = Object.values(ROLES);
